import { canReorderRow } from "../row-policy";
import type { EmailDocument, Selection } from "../types";
import {
  canDeleteColumn,
  canDeleteGroup,
  canDeleteRowSelection,
  canDuplicateColumn,
  canMoveBlockInColumn,
  canMoveColumnInRow,
  canMoveGroup,
  canMoveRowSelection,
  canUngroupGroup,
  isBlockSelection,
} from "./ops";

export type SelectionCapabilities = {
  canUp: boolean;
  canDown: boolean;
  canDuplicate: boolean;
  canDelete: boolean;
  canUngroup: boolean;
  showMoveButtons: boolean;
  upLabel: string;
  downLabel: string;
};

export function getSelectionCapabilities(
  document: EmailDocument,
  selection: Selection,
): SelectionCapabilities | null {
  if (selection.kind === 'email') {
    return null;
  }

  let canUp = false;
  let canDown = false;
  let canDuplicate = true;
  let canDelete = true;
  let canUngroup = false;

  if (isBlockSelection(selection)) {
    canUp = canMoveBlockInColumn(document, selection, -1);
    canDown = canMoveBlockInColumn(document, selection, 1);
  } else if (selection.kind === 'column') {
    canUp = canMoveColumnInRow(document, selection, -1);
    canDown = canMoveColumnInRow(document, selection, 1);
    canDuplicate = canDuplicateColumn(document, selection);
    canDelete = canDeleteColumn(document, selection);
  } else if (selection.kind === 'row') {
    canUp = canMoveRowSelection(document, selection, -1);
    canDown = canMoveRowSelection(document, selection, 1);
    canDelete = canDeleteRowSelection(document, selection);
  } else if (selection.kind === 'group') {
    canUp = canMoveGroup(document, selection, -1);
    canDown = canMoveGroup(document, selection, 1);
    canDelete = canDeleteGroup(document);
    canUngroup = canUngroupGroup(document, selection.groupId);
  }

  const showMoveButtons =
    selection.kind !== 'row' || canReorderRow(document, selection.rowId);

  const upLabel = selection.kind === 'column' ? 'Move left' : 'Move up';
  const downLabel = selection.kind === 'column' ? 'Move right' : 'Move down';

  return {
    canUp,
    canDown,
    canDuplicate,
    canDelete,
    canUngroup,
    showMoveButtons,
    upLabel,
    downLabel,
  };
}
